import { useContext, useState, useEffect } from "react";
import * as ReactDOM from "react-dom";
import Draggable from "react-draggable";

import "./DeadlineBanner.css";
import { LanguageContext } from "context";
import { useSessionContext } from "context/SessionContext";
import { useNotification } from "context/NotificationContext";

import { getBannerInfo } from "../../../../shared/api/banner";

const DeadlineBanner = ({ visible, onClose }: { visible: boolean; onClose: () => void }) => {
  const bannerRoot = document.getElementById("banner-root");
  const { t } = useContext(LanguageContext) as any;
  const { session } = useSessionContext();
  const { showNotification } = useNotification();

  const [daysCount, setdaysCount] = useState(null);
  const [dlMessage, setdlMessage] = useState("");

  console.log(`DeadlineBanner::visible=${visible}`);
  if (!visible || !bannerRoot) return null;

   useEffect(() => {
    const fetchBannerInfo = async () => {
      try {
        if (!session?.access_token) {
          return;
        }
        const data = await getBannerInfo(session.access_token);
        console.log(`getBannerInfo::${JSON.stringify(data)}`);

        setdaysCount(data.deadline_days);
        setdlMessage(data.banner_message);
      } catch (err) {
        console.error("バナー情報取得エラー", err);
        showNotification({
          icon: "error",
          title: t("Common.error"),
          message: t("Common.get-error"),
        }, 3000);
      }
    };

    fetchBannerInfo();
  }, [session?.access_token]);

  return ReactDOM.createPortal(
    <Draggable handle=".banner-wrapper">
      <div className="banner-wrapper">
        <div className="line deadline">{t("DeadlineBanner.title1")}</div>
        <div className="line until">
          <div>{t("DeadlineBanner.title2")}</div>
          <div>{t("DeadlineBanner.title3")}</div>
        </div>
        <div className="line day">
          <div className="number">{daysCount}</div>
          <div className="unit">{t("DeadlineBanner.day")}</div>
        </div>
        <button className="close-button" onClick={onClose}>
          ×
        </button>
        <div className="message-bar">{dlMessage}</div>
      </div>
    </Draggable>,
    bannerRoot
  );
};

export default DeadlineBanner;
